export const API_BASE_URL = "https://testqrmenu.flexbyts.com/api";
// export const API_BASE_URL = "http://127.0.0.1:8000/api";
